export const CREATE_CASH_RECEIPT = 'CREATE_CASH_RECEIPT';
export const GET_CASH_RECEIPTS = 'GET_CASH_RECEIPTS';
export const CASH_RECEIPT_REQUEST = 'CASH_RECEIPT_REQUEST';
export const DELETE_CASH_RECEIPT = 'DELETE_CASH_RECEIPT';
export const UPDATE_CASH_RECEIPT = 'UPDATE_CASH_RECEIPT';
export const CASH_RECEIPT_REQUEST_SUCCESS = 'CASH_RECEIPT_REQUEST_SUCCESS';
export const CASH_RECEIPT_REQUEST_FAILURE = 'CASH_RECEIPT_REQUEST_FAILURE';
export const GET_CASH_RECEIPTS_PAGE = 'GET_CASH_RECEIPTS_PAGE';